/* eslint-disable */
import React from 'react';
import { Grid } from '@mui/material';
import SectionCard from './SectionCard';
import { StyledField, StyledSelect } from './helpers';

const VILLES = ['Casablanca', 'Rabat', 'Marrakech', 'Fès', 'Tanger', 'Agadir', 'Oujda', 'Meknès'];

const IdentificationSection = ({ data, onChange }) => (
  <SectionCard
    id="identification"
    title="Identification"
    subtitle="Modifiez vos informations d'identification"
  >
    <Grid container spacing={2}>
      <Grid item xs={4}>
        <StyledField
          label="Code client"
          value={data.codeClient}
          disabled
        />
      </Grid>
      <Grid item xs={4}>
        <StyledField
          label="Intitulé compte"
          name="intituleCompte"
          value={data.intituleCompte}
          onChange={onChange}
        />
      </Grid>
      <Grid item xs={4}>
        <StyledField
          label="Téléphone"
          name="telephone"
          value={data.telephone}
          onChange={onChange}
        />
      </Grid>
      <Grid item xs={4}>
        <StyledField
          label="E-mail"
          name="email"
          value={data.email}
          onChange={onChange}
        />
      </Grid>
      <Grid item xs={4}>
        <StyledSelect
          label="Ville"
          name="ville"
          value={data.ville}
          onChange={onChange}
          options={VILLES}
        />
      </Grid>
      <Grid item xs={4}>
        <StyledField
          label="Adresse"
          name="adresse"
          value={data.adresse}
          onChange={onChange}
        />
      </Grid>
    </Grid>
  </SectionCard>
);

export default IdentificationSection;